export interface DeleteDefaultParameterCollectionRequest {
  id: string
  revision: number
}

export function DeleteDefaultParameterCollectionRequestToJSON(
  value: DeleteDefaultParameterCollectionRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision ? value.revision : undefined
  }
}
